import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { AppSolicitudes } from '../models/appSolicitides.model';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';
import { AppEmpresasService } from './appEmpresasService.service';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { DatosSolicitudesMesVSModel, DatosTiposSolicitudesModel } from '../models/datosSolicitudes.model';
import { LivesSessionHelper } from '../helper/livesSessionHelper';


//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable()
export class AppSolicitudesService extends HttpClientBaseService implements IServiceBase<AppSolicitudes> {

  constructor(
    _http: HttpClient,
    private appEmpresasService: AppEmpresasService,
    private _livesSession: LivesSessionHelper,
  ) {
    super(_http, '/requests/', '', false);


  }
  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppSolicitudes>> {
    throw new Error('Method not implemented.');
  }


  /*   getAllModels(): Observable<AppSolicitudes[]> {
  
      const url = `${AppConfig.settings.apiServerPE.apiUrl}request`;
  
      // Crear los headers con la clave API
      const headers = new HttpHeaders({
        'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
      });
  
  
      return this.http.get<AppSolicitudes[]>(url, { headers: headers });
    } */

  getAllModels(): Observable<AppSolicitudes[]> {
    let companiesList: { companyId: string, companyCode: number }[] = [];
    let userLogged = this._livesSession.AspNetUserId;
    const environmentId = this._livesSession.EnvironmentId

    // Obtener la lista de empresas y guardar los valores de company1 en companiesList
    return this.appEmpresasService.getAllModels().pipe(
      mergeMap((response) => {
        response.forEach((item) => {
          if (item.company1) {
            companiesList.push({ companyId: item.company1, companyCode: item.companyCode });
          }
        });

        if (companiesList.length === 0) {
          return of([] as AppSolicitudes[]);
        }

        // Crear un array de observables para las consultas a 'request'
        const observables = companiesList.map(({ companyId, companyCode }) => {



          const url = `${AppConfig.settings.apiServerPE.apiUrl}request?companyCode=${companyCode}&environmentId=${environmentId}&fields=company&operator=eq&values=${companyId}&orderBy=createdAt&order=desc`;
          const headers = new HttpHeaders({
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
          });

          return this.http.get<AppSolicitudes[]>(url, { headers: headers }).pipe(
            catchError((error) => of([] as AppSolicitudes[])) // Maneja errores y retorna un arreglo de AppSolicitudes vacío
          );
        });

        // Combinar todos los observables en uno solo
        return forkJoin(observables).pipe(
          map(results => results.reduce((acc, val) => acc.concat(val), [] as AppSolicitudes[])) // Aplana y asegura el tipo correcto
        );
      }),
      catchError((error) => {
        console.error('Error al obtener solicitudes', error);
        return of([] as AppSolicitudes[]); // Retorna un observable vacío en caso de error.
      })
    );
  }

  getAllModelsByDate(date: Date): Observable<AppSolicitudes[]> {
    let companiesList: { companyId: string, companyCode: number }[] = [];
    let userLogged = this._livesSession.AspNetUserId;
    const environmentId = this._livesSession.EnvironmentId

    // Calcular el primer y último día del mes en formato ISO
    const startDate = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0).toISOString();
    const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999).toISOString();

    
    // Obtener la lista de empresas y guardar los valores de company1 en companiesList
    return this.appEmpresasService.getAllModels().pipe(
      mergeMap((response) => {
        response.forEach((item) => {
          if (item.company1) {
            companiesList.push({ companyId: item.company1, companyCode: item.companyCode });
          }
        });

        if (companiesList.length === 0) {
          return of([] as AppSolicitudes[]);
        }

        // Crear un array de observables para las consultas a 'request'
        const observables = companiesList.map(({ companyId, companyCode }) => {



          const url = `${AppConfig.settings.apiServerPE.apiUrl}requests/calendar?startDate=${startDate}&endDate=${endDate}&companyCode=${companyCode}&environmentId=${environmentId}&fields=company&operator=eq&values=${companyId}&orderBy=createdAt&order=desc`;
          const headers = new HttpHeaders({
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
          });

          return this.http.get<AppSolicitudes[]>(url, { headers: headers }).pipe(
            catchError((error) => of([] as AppSolicitudes[])) // Maneja errores y retorna un arreglo de AppSolicitudes vacío
          );
        });

        // Combinar todos los observables en uno solo
        return forkJoin(observables).pipe(
          map(results => results.reduce((acc, val) => acc.concat(val), [] as AppSolicitudes[])) // Aplana y asegura el tipo correcto
        );
      }),
      catchError((error) => {
        console.error('Error al obtener solicitudes', error);
        return of([] as AppSolicitudes[]); // Retorna un observable vacío en caso de error.
      })
    );
  }

  getAllModelsByEmployee(employeeId: string, companyCode: string, companyId: string): Observable<AppSolicitudes[]> {

    const environmentId = this._livesSession.EnvironmentId;
    const url = `${AppConfig.settings.apiServerPE.apiUrl}request?orderBy=createdAt&order=desc&companyCode=${companyCode}&environmentId=${environmentId}&fields=company&fields=user&operator=eq&operator=eq&values=${companyId}&values=${employeeId}`;

    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.get<AppSolicitudes[]>(url, { headers }).pipe(
      catchError((error) => {
        console.error('Error al obtener solicitudes', error);
        return of([] as AppSolicitudes[]);
      })
    );
  }

  getCompanyYearModels(companyCode: number, year: number): Observable<AppSolicitudes[]> {
    let companiesIdList: string[] = [];
    let userLogged = this._livesSession.AspNetUserId;

    // Obtener la lista de empresas y guardar los valores de company1 en companiesIdList
    return this.appEmpresasService.getAllModels().pipe(
      mergeMap((response) => {
        response.forEach((item) => {
          if (item.company1) {
            companiesIdList.push(item.company1);
          }
        });

        if (companiesIdList.length === 0) {
          return of([] as AppSolicitudes[]);
        }

        // Crear un array de observables para las consultas a 'request'
        const observables = companiesIdList.map((companyId) => {
          const url = `${AppConfig.settings.apiServerPE.apiUrl}request?createdAtYear=${year}&companyCode=${companyCode}`;
          const headers = new HttpHeaders({
            'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
          });

          return this.http.get<AppSolicitudes[]>(url, { headers: headers }).pipe(
            catchError((error) => of([] as AppSolicitudes[])) // Maneja errores y retorna un arreglo de AppSolicitudes vacío
          );
        });

        // Combinar todos los observables en uno solo
        return forkJoin(observables).pipe(
          map(results => results.reduce((acc, val) => acc.concat(val), [] as AppSolicitudes[])) // Aplana y asegura el tipo correcto
        );
      }),
      catchError((error) => {
        console.error('Error al obtener solicitudes', error);
        return of([] as AppSolicitudes[]); // Retorna un observable vacío en caso de error.
      })
    );
  }



  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('es-ES', options);
  }


  addOneDay(date: Date): Date {
    date.setDate(date.getDate() + 1);
    return date;
  }

  addOneDayAndFormat(date: Date): string {
    const newDate = this.addOneDay(date);
    return this.formatDate(newDate);
  }



  getModel(id: any): Observable<AppSolicitudes> {
    return super.getSingle<AppSolicitudes>(id);
  }

  /*   getModelCompanyYear(id: any): Observable<AppSolicitudes> {
      return super.getSingle<AppSolicitudes>(id);
    } */


  getTypesGraphsData(companyCode: number, year: number): Observable<DatosTiposSolicitudesModel[]> {
    return this.getCompanyYearModels(companyCode, year).pipe(
      map(data => {
        if (data.length === 0) {
          return [
            { TipoSolicitud: 'Vacaciones', Porcentaje: 0 },
            { TipoSolicitud: 'Absentismos', Porcentaje: 0 },
            { TipoSolicitud: 'Cambio de datos', Porcentaje: 0 }
          ];
        }

        // Filtrar las solicitudes por tipo
        const vacaciones = data.filter(item => item.type === 'Vacaciones');
        const cambioDatos = data.filter(item => item.type === 'Cambio de datos');
        const absentismos = data.filter(item => item.type !== 'Vacaciones');

        // Calcular la cantidad total de solicitudes
        const totalSolicitudes = data.length;

        // Verificar si hay solicitudes antes de calcular los porcentajes
        let porcentajeVacaciones = 0;
        let porcentajeCambioDatos = 0;
        let porcentajeAbsentismos = 0;
        if (totalSolicitudes > 0) {
          porcentajeVacaciones = (vacaciones.length / totalSolicitudes) * 100;
          porcentajeCambioDatos = (cambioDatos.length / totalSolicitudes) * 100;
          porcentajeAbsentismos = (absentismos.length / totalSolicitudes) * 100;
        }

        // Crear el array de objetos con el tipo de solicitud y su respectivo porcentaje
        const resultados = [
          { TipoSolicitud: 'Vacaciones', Porcentaje: porcentajeVacaciones },
          { TipoSolicitud: 'Absentismos', Porcentaje: porcentajeAbsentismos },
          { TipoSolicitud: 'Cambio de datos', Porcentaje: porcentajeCambioDatos }
        ];

        return resultados;
      })
    );
  }


  getMonthsVSGraphsData(companyCode: number, year: number): Observable<DatosSolicitudesMesVSModel[]> {
    return this.getCompanyYearModels(companyCode, year).pipe(
      map(data => {
        // Objeto para almacenar los datos por mes
        const datosPorMes: { [mes: number]: DatosSolicitudesMesVSModel } = {};

        for (let i = 1; i <= 12; i++) {
          datosPorMes[i] = {
            Mes: i,
            NombreMes: this.getMonthName(i), // Obtener el nombre del mes
            TotalPendiente: 0,
            TotalGestionadas: 0
          };
        }

        data.forEach(item => {
          const fecha = new Date(item.createdAt);
          const mes = fecha.getMonth() + 1; // Meses son indexados desde 0 en JavaScript, por eso sumamos 1
          const estado = item.stateHr.requestState1 === 0 ? 'Pendiente' : 'Gestionada'; // Determinar el estado de la solicitud


          if (estado === 'Pendiente') {
            datosPorMes[mes].TotalPendiente++;
          } else {
            datosPorMes[mes].TotalGestionadas++;
          }
        });

        const resultados = Object.values(datosPorMes);

        return resultados;
      })
    );
  }


  getMonthName(mes: number): string {
    const nombresMeses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    return nombresMeses[mes - 1];
  }


  public getCompany(userName: string): Observable<AppSolicitudes> {
    const url = `${this.getConcatUrl()}GetByUserName/${userName}`;
    return super.get<AppSolicitudes>(url);
  }

  public updateModel(id: string, data: Partial<AppSolicitudes>): Observable<AppSolicitudes> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}request/${id}`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    const payload = {
      ...data,
      source: 'WEB',
      modifiedBy: AppConfig.settings.apiServerPE.system
    };
    // Realizar la petición PATCH y devolver el resultado como un Observable
    return this.http.patch<AppSolicitudes>(url, payload, { headers: headers });
  }

  public updateAdvanceRequest(id: string, data: Partial<AppSolicitudes>): Observable<any> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}advance/request?advanceRequestId=${id}`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });


    // Realizar la petición PATCH y devolver el resultado como un Observable
    return this.http.patch<any>(url, data, { headers: headers });
  }

}